module.exports = __webpack_public_path__ + "img/logo1.6c98a3da.png";